import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import JobsSummary from './Widgets/JobsSummary';
import Notifications from './Notifications';
import Onboarding from './Widgets/Onboarding';
import Stats from './Widgets/Stats';
import { Sections } from '../../Components/Containers/Section';
import { useSession } from '../../Components/Session';
import BusinessSwitcher from './BusinessSwitcher';
import Threads from './Widgets/Threads';
import UpdatesAvailable from './Widgets/UpdatesAvailable';
import MobileNotifications from './Widgets/MobileNotifications';
import { Roles } from '../../Data/Users';
import { Link } from 'react-router-dom';

const Home = () => {
    const {isRoleSufficient} = useSession();

    return <>
        <TopBar
            left={<BusinessSwitcher />}
            title={
                <img src="/logo-name-horizontal-36.png"
                    className="h-[36px] w-[175px] mt-1 mx-auto"
                    alt="getSoapy"
                    width="175"
                    height="36"
                    onClick={() => window.location.reload(true)}
                />
            }
            right={<Notifications />}
        />

        <Page>
            <Sections>
                <UpdatesAvailable />
                <MobileNotifications />
                {isRoleSufficient(Roles.Manager) && <>
                    <Onboarding />
                    <Stats />
                    <JobsSummary />
                    <Threads />
                </>}
                {!isRoleSufficient(Roles.Manager) && <>
                    <p>Sorry, there's not much to see here using your current role.</p>
                    <span>
                        <Link to="/work" className="btn btn-primary">Work view</Link>
                    </span>
                </>}
            </Sections>

        </Page>
    </>
}

export default Home;
